(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-custom-collection-series"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var mySwiper = new Swiper('.new-custom-collection-series.swiper', {
      loop: false,
      slidesPerView: 6,
      spaceBetween: 16,
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1550: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
